import get from 'lodash/get';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import replace from 'lodash/replace';
import { isNonEmptyString } from './isNonEmptyString';

const applicantFieldsToMask = [
  'birthDate',
  'cellPhone',
  'emailAddress',
  'firstName',
  'lastName',
  'ssn'
];

const employmentFieldsToMask = [
  'employerName'
];

const residenceAddressFieldsToMask = [
  'lineOne',
  'lineTwo'
];

/**
 * Masks all characters in the provided string
 *
 * @param {*} value
 * @returns {*}
 */
const maskValue = (value) =>
  isString(value) ? replace(value, /./ig, '*') : value;

/**
 * Responsible for checking each section of the
 * applicant's data for fields to mask
 *
 * @param {Object} applicant
 * @returns {Object}
 */
const maskApplicantValues = (applicant) => {
  applicantFieldsToMask.forEach((prop) => {
    applicant[prop] = maskValue(applicant[prop]);
  });

  if (isObject(applicant.currentEmployment)) {
    employmentFieldsToMask.forEach((prop) => {
      applicant.currentEmployment[prop] = maskValue(
        applicant.currentEmployment[prop]
      );
    });
  }

  if (isObject(applicant.previousEmployment)) {
    employmentFieldsToMask.forEach((prop) => {
      applicant.previousEmployment[prop] = maskValue(
        applicant.previousEmployment[prop]
      );
    });
  }

  if (isObject(applicant.primaryResidence)) {
    residenceAddressFieldsToMask.forEach((prop) => {
      applicant.primaryResidence.physicalAddress[prop] = maskValue(
        applicant.primaryResidence.physicalAddress[prop]
      );
    });
  }

  if (isObject(applicant.previousResidence)) {
    residenceAddressFieldsToMask.forEach((prop) => {
      applicant.previousResidence.physicalAddress[prop] = maskValue(
        applicant.previousResidence.physicalAddress[prop]
      );
    });
  }

  return applicant;
};

/**
 * Returns the request body with PII values masked (if applicable)
 *
 * @param {*} requestBody
 * @returns {*}
 */
export const sanitizeRequestBody = (requestBody) => {
  if (isNonEmptyString(requestBody)) {
    try {
      const data = JSON.parse(requestBody);

      const applicants = get(data, 'applicants', []);

      applicants.forEach((applicant, index) => {
        applicants[index] = maskApplicantValues(applicant);
      });

      return JSON.stringify(data);
    } catch {
      return requestBody;
    }
  }

  return requestBody;
};
